import { css } from "@emotion/react";
import styled from "@emotion/styled";
import {
  Button,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledStepTitle = styled(Text)`
  margin: 0px;
`;

export const StyledSection = styled("div")`
  display: flex;
  flex-direction: column;
  margin: 24px 0px;
`;

export const StyledSectionTitle = styled(Text)`
  margin-bottom: 10px;
`;
export const StyledSubSection = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-bottom: 20px;
`;

export const StyledSubSectionTitle = styled(Text)``;

export const StyledRow = styled("div")`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-left: 20px;
`;

export const StyledNavigationButtonsContainer = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin: 24px 0px;
`;

export const StyledFormFieldContainer = styled("div")`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;

export const StyledFormFieldOverlay = styled("div", {
  shouldForwardProp: (prop) => prop !== "$isDebug",
})<{ $isDebug: boolean }>`
  padding: 5px;

  ${({ $isDebug }) =>
    $isDebug &&
    css`
      border: 1px solid blue;
      border-radius: 5px;
    `}
`;

export const StyledNextButton = styled(Button)`
  color: white;
`;

export const StyledPreviousButton = styled(Button)`
  color: ${({ theme }) => theme.palette.primary[500]};
`;
